import type {
  VesselNomination,
  VesselNominationApiItem,
  VesselNominationsApiResponse,
  VesselNominationsResponse,
} from "@services/vessel-nomination/types";

export const mapVesselNominationResponseItem = (
  item: VesselNominationApiItem,
): VesselNomination => ({
  id: item.id ?? String(item.refOrderNumber ?? ""),
  nominationId: item.refOrderNumber ?? null,
  nominationType: item.nominationType ?? null,
  imoNumber: item.vesselImo ?? null,
  vesselName: item.vesselName ?? null,
  port: item.port ?? null,
  agencyName: item.shippingAgency ?? null,
  eta: item.rta ?? null,
  createdAt: item.createdAt ?? null,
  status: item.status ?? null,
});

export const mapVesselNominationsResponse = (
  response: VesselNominationsApiResponse,
): VesselNominationsResponse => ({
  ...response,
  items: response.items.map(mapVesselNominationResponseItem),
});
